import React from 'react';
import { motion } from 'framer-motion';
import { cvData } from '../data/cvData';
import { uiTranslations } from '../data/translations';
import { useLanguage } from '../context/LanguageContext';
import SectionHeader from './SectionHeader';

export default function Education() {
  const { language } = useLanguage();
  const data = cvData[language];
  const t = uiTranslations[language].sections.education;

  if (!data.education || data.education.length === 0) return null;

  return (
    <section id="education" className="py-24 bg-white border-t border-slate-50">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <SectionHeader title={t.title} label={t.label} />
        <div className="space-y-12 max-w-4xl">
          {data.education.map((edu, index) => (
            <motion.div key={edu.id} initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: index * 0.1 }} className="flex flex-col md:flex-row gap-6 md:gap-12">
              <div className="md:w-32 flex-shrink-0">
                <span className="text-sm font-bold text-accent tracking-wider">{edu.period}</span>
              </div>
              <div className="flex-grow">
                <h3 className="text-xl font-bold text-slate-900 mb-1">{edu.institution}</h3>
                <p className="text-slate-600 italic">{edu.degree}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}